import Button from "components/Button/index";
import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowdark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import React, { useRef, useState, useEffect } from "react";
import "./editRoleOperations.scss";
import useTheme from "hooks/observer";
import SquareCheckBox from "components/SquareCheckBox/index";
import { listPermissions } from "@induz/sdk";
// import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";

const EditRoleOperations = ({ team, updateOperations }) => {
  const theme = useTheme();
  const arrow = theme === "light" ? upArrow : upArrowdark;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOperations, setSelectedOperations] = useState(
    team?.operations || []
  );

  const dropdownRef = useRef(null);
  // console.log("Teams: ", selectedOperations);

  
  const perms = listPermissions();
  const dropdownData = perms
    .filter((perm) => perm !== "RestoreVersion")
    .map((perm) => ({ role: perm }));
  // const dropdownData = [
  //   { role: "Product Designer" },
  //   { role: "Frontend Developer" },
  //   { role: "QA Analyst" },
  //   { role: "Sales Lead" },
  //   { role: "Backend Developer" },
  //   { role: "DevOps" },
  //   { role: "Marketing Coordinator" },
  //   { role: "Support Specialist" }
  // ];
  const selectedRoles = new Set(selectedOperations.map(op => op.role));

  const newCheckedState = dropdownData.map(item => selectedRoles.has(item.role));
  const [checkedStates, setCheckedStates] = useState(newCheckedState);
  // console.log("States: ", checkedStates);

  // useEffect(() => {
  //   setSelectedOperations(team?.operations || []);
  //   setCheckedStates(
  //     dropdownData.map((item) => team?.operations.includes(item.role))
  //   );
    
  // }, [team?.operations]);
  useEffect(() => {
  if (team?.operations) {
    setSelectedOperations(team.operations);
    const selectedRoles = new Set(team.operations.map((item) => item.role));
    setCheckedStates(dropdownData.map((item) => selectedRoles.has(item.role)));
  } 
  }, [team?.operations]);

  useEffect(() => {
    const selectedRoles = new Set(selectedOperations.map((item) => item.role));
    setCheckedStates(dropdownData.map((item) => selectedRoles.has(item.role)));
  }, [selectedOperations]);


    

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    if(!isDropdownOpen){
    document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const handleCheckboxChange = (index) => {
  //   const newCheckedStates = [...checkedStates];
    
  //   newCheckedStates[index] = !newCheckedStates[index];
  //   setCheckedStates(newCheckedStates);
    

  //   const updatedSelectedOperations = dropdownData
  //     .filter((_, i) => newCheckedStates[i])
  //     .map((item) => item.role);
  //   setSelectedOperations(updatedSelectedOperations);
  // };

  const handleCheckboxChange = (index) => {
    const role = dropdownData[index].role;

    const updatedCheckedStates = [...checkedStates];
    updatedCheckedStates[index] = !updatedCheckedStates[index];
    setCheckedStates(updatedCheckedStates);

    let updatedSelectedOperations = [...selectedOperations];

    if (updatedCheckedStates[index]) {
      // Add if not already selected
      if (!updatedSelectedOperations.includes(role)) {
        updatedSelectedOperations.push({role: role});
      }
    } else {
      // Remove if unchecked
      updatedSelectedOperations = updatedSelectedOperations.filter(
        (op) => op.role !== role
      );
    }

    setSelectedOperations(updatedSelectedOperations);
  };


      

  const truncateRole = (role) => {
    if (!role) return "";
    const roleStr = typeof role === "string" ? role : role?.role ?? "No roles";
    const parts = roleStr.split(" ");
    if (Array.isArray(parts) && parts.length > 1) {
      return `${parts[0]} ${parts[1].charAt(0)}...`;
    }
    return roleStr.length > 8 ? `${roleStr.substring(0, 8)}...` : roleStr;
  };

  const filteredDropdownData = dropdownData.filter((item) =>
    item.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // const renderSelectedOperations = () => (
  //   <div className="eroSelectedRolesContainer">
  //     {!isDropdownOpen ? (
  //       <>
  //         <div className="eroRoleChips">
  //           {selectedOperations.length > 0 ? (
  //             selectedOperations.slice(0, 2).map((role, index) => (
  //               <span key={index} className="eroRoleChip">
  //                 {truncateRole(role)}
  //               </span>
  //             ))
  //           ) : (
  //             <span className="eroNoRoles">No operations in team</span>
  //           )}
  //           {selectedOperations.length > 2 && (
  //             <span className="eroRemainingCount">
  //               +{selectedOperations.length - 2}
  //             </span>
  //           )}
  //         </div>
  //         {/* <div
  //           className="eroCross"
  //           onClick={() => {
  //             setCheckedStates(Array(dropdownData.length).fill(false));
  //             setSelectedOperations([]);
  //             setSearchTerm("");
  //             updateOperations([]);
  //           }}
  //         >
  //           <GetActionIcon
  //             type="cross"
  //             color={theme === "light" ? "#7D708A" : "#BDB8C2"}
  //           /> 
  //         </div> */}
  //         <div
  //           className="eroDropdownArrow"
  //           onClick={()=> {
  //             setCheckedStates(checkedStates);
  //             setSelectedOperations(selectedOperations);
  //             setSearchTerm("");
  //             updateOperations(selectedOperations);
  //           }}    
  //         >
  //         <img
  //           src={arrow}
  //           alt="arrow"
  //           className="eroDropdownArrow"
  //           onClick={() => setIsDropdownOpen(false)}
  //         />
  //         </div>
  //       </>
  //     ) : (
  //       <>
  //         <input
  //           type="text"
  //           placeholder="Select operations"
  //           className="eroRoleInput"
  //           value={searchTerm}
  //           onChange={(e) => setSearchTerm(e.target.value)}
  //           autoFocus
  //         />
  //         <img
  //           src={arrow}
  //           alt="arrow"
  //           className="eroDropdownArrow"
  //           onClick={() => setIsDropdownOpen(false)}
  //         />
  //       </>
  //     )}
  //   </div>
  // );
  const renderSelectedOperations = () => (
  <div className="eroSelectedRolesContainer">
    <div className="eroRoleChips">
      {selectedOperations.length > 0 ? (
        selectedOperations.slice(0, 2).map((role, index) => (
          <span key={index} className="eroRoleChip">
            {truncateRole(role)}
          </span>
        ))
      ) : (
        <span className="eroNoRoles">No operations in team</span>
      )}
      {selectedOperations.length > 2 && (
        <span className="eroRemainingCount">
          +{selectedOperations.length - 2}
        </span>
      )}
    </div>

    {isDropdownOpen && (
      <input
        type="text"
        placeholder="Select operations"
        className="eroRoleInput"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        autoFocus
      />
    )}

    <img
      src={arrow}
      alt="arrow"
      className="eroDropdownArrow"
      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
    />
  </div>
);


  return (
    <div className="EditRoleOperations">
      <div className="EditRoleOperationsWrapper">
        <div className="EditRoleOperationsWrapperContent" ref={dropdownRef}>
          <p>Edit Permissions</p>
          <div
            className="eroSelectRole"
            onClick={() => {
              if (!isDropdownOpen) {
                setIsDropdownOpen(true);
                setSearchTerm("");
              }
            }}
          >
            <div className="eroRole">{renderSelectedOperations()}</div>
            {isDropdownOpen && (
              <div className="eroRoleDropdown">
               <ul>
                {filteredDropdownData.map((option, index) => (
                  <li key={option.role} className="eroNotificationItem" onClick={() => handleCheckboxChange(index)}>
                    <SquareCheckBox
                      labelStyles={{
                        color: "var(--text-grey-strong)",
                        fontFamily: "Helvetica, sans-serif"
                      }}
                      isChecked={checkedStates[index]}
                      handleCheck={() => handleCheckboxChange(index)}
                    />
                    <div className="eroContent">
                      <p>{option.role}</p>
                    </div>
                  </li>
                ))}
              </ul>

                <div className="eroRoleDropdownButtons">
                  <Button
                    type="white"
                    title="Clear"
                    width="50%"
                    onClick={() => {
                      setCheckedStates(Array(dropdownData.length).fill(false));
                      setSelectedOperations([]);
                      setSearchTerm("");
                      updateOperations([]);
                    }}
                  />
                  <Button
                    type="violet"
                    title="Select"
                    width="50%"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      updateOperations(selectedOperations);
                    }}
                    disabled={selectedOperations.length === 0}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRoleOperations;
